<template>
  <div class="ui right aligned container">
    <div class="channel"><a href="/#/bilibili/channel">杨超越频道数据</a></div>
    <date-picker class="date" format="YYYY-MM-DD" type="date" valueType="format" v-model="after"></date-picker>
    <div class="ui icon input">
      <input type="text" v-model="search" placeholder="Search">
      <i v-if="search" class="circular close link icon" @click="search=''"></i>
      <i v-else class="inverted circular search link icon"></i>
    </div>
    <button id="add" class="ui icon button" @click="modal=true" v-if="user.isAdmin"><i class="add icon"></i></button>
    <button @click="refresh()" class="ui primary icon button" id="refresh"><i class="sync icon"></i></button>
    <vuetable ref="vuetable"
              :api-url="'/bilibili?after='+after"
              :fields="fields"
              :initialPage="page"
              :sort-order="sortOrder"
              :search="search"
              :route="true"
              @vuetable:route-change="onRouteChange"
              @vuetable:pagination-data="onPaginationData"
    >
      <template slot="actions" scope="props">
        <i class="trash alternate outline link icon" title="删除" @click="hide(props.rowData)" v-if="user.isAdmin"></i>
        <i class="ban link icon" title="拉黑" @click="block(props.rowData)" v-if="user.isAdmin"></i>
        <i class="refresh link icon" title="刷新" @click="refreshVideo(props.rowData)" v-if="user.isAdmin"></i>
      </template>
    </vuetable>
    <div class="ui grid">
      <div class="ui left aligned six wide column">
        <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
      </div>
      <div class="right floated six wide column">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
      </div>
    </div>

    <Modal v-model="modal" title="添加视频">
      <div class="ui input">
        <input type="text" placeholder="BVID" v-model="bvid">
      </div>
      <template slot="actions">
        <div @click="modal=false" class="ui cancel button">取消</div>
        <div @click="onSubmit" class="ui positive button" :class="{disabled:!bvid.startsWith('BV')}">添加</div>
      </template>
    </Modal>
  </div>
</template>
<style scoped>
  .black {
    color: red;
  }

  #add {
    margin-left: 12px;
  }

  .channel {
    float: left;
  }

  .date {
    margin-right: 12px;
  }
</style>
<script>
  import DatePicker from 'vue2-datepicker';
  import auth from '../../services/Auth';
  import Vuetable from '../../table/Vuetable.vue';
  import VuetablePagination from '../../table/VuetablePagination.vue';
  import VuetablePaginationInfo from '../../table/VuetablePaginationInfo.vue';
  import axios from 'axios';
  import Modal from '@/components/Modal'

  export default {
    name: 'BilibiliList',
    components: {
      Modal,
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
      DatePicker,
    },
    mounted() {
      this.user = auth.user;
    },
    data() {
      return {
        page: +this.$route.params.page || 1,
        search: '',
        sort: 'date,desc',
        after: '',
        bvid: '',
        modal: false,
        user: {},
        fields: [
          {name: 'title', title: '标题', callback: 'image'},
          {name: 'type', title: '分类'},
          {name: 'author', title: '作者', callback: 'userlink'},
          {name: 'play', title: '播放', sortField: 'play'},
          {name: 'coin', title: '投币', sortField: 'coin'},
          {name: 'like', title: '点赞', sortField: 'like'},
          {name: 'favorites', title: '收藏', sortField: 'favorites'},
          {name: 'danmaku', title: '弹幕', sortField: 'danmaku'},
          {name: 'share', title: '分享', sortField: 'share'},
          {name: 'date', title: '日期', sortField: 'date', callback: 'date'},
          {name: 'duration', title: '时长', sortField: 'duration', callback: 'duration'},
          {name: 'accessed', title: '已阅', callback: 'yes'},
          {name: '__slot:actions', title: ''}
        ],
      };
    },
    computed: {
      sortOrder() {
        const parts = this.sort.split(',');
        return [
          {
            field: parts[0],
            sortField: parts[0],
            direction: parts[1]
          }
        ];
      }
    },
    watch: {
      '$route'(to) {
        this.page = +to.params.page;
        this.after = to.query.after || '';
        this.search = to.query.search || '';
        this.sort = to.query.sort || 'date,desc';
      }
    },
    methods: {
      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData);
        this.$refs.paginationInfo.setPaginationData(paginationData);
      },
      onRouteChange(data) {
        let path = '/bilibili/' + (data.page + 1);
        let query = {};
        if (this.after) {
          query.after = this.after;
        }
        if (this.search) {
          query.search = this.search;
        }
        if (data.sort) {
          query.sort = data.sort;
        }
        this.$router.push({path: path, query: query});
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      },
      yes: function (value) {
        if (value) {
          return '<i class="check icon"></i>'
        } else {
          return ''
        }
      },
      link: function (value, item) {
        if (this.user.authenticated) {
          return '<a href="/bilibili/' + item.id + '?X-ACCESS-TOKEN=' + localStorage.getItem('access_token') + '" target="_blank">' + value + '</a>';
        }
        return '<a href="https://www.bilibili.com/video/av' + item.id + '" target="_blank">' + value + '</a>';
      },
      image: function (value, item) {
        let link = "https://www.bilibili.com/video/" + (item.bvid ? item.bvid : 'av' + item.id);
        if (this.user.authenticated) {
          link = '/bilibili/' + item.id + '?X-ACCESS-TOKEN=' + localStorage.getItem('access_token');
        }
        let href = '<a ' + (item.blocked ? 'class="black" title="黑粉或营销号"' : '') + ' href="' + link + '" target="_blank">' + value + '</a>';
        //let image = `<a class="image" href="${item.cover.replace('http:', 'https:')}" target="_blank"><i class="image icon"></i></a>`;
        return href;
      },
      userlink: function (value, item) {
        return '<a ' + (item.blocked ? 'class="black" title="黑粉或营销号"' : '') + ' href="https://space.bilibili.com/' + item.authodId + '" target="_blank">' + value + '</a>';
      },
      date: function (value) {
        let date = new Date(value);
        return '<span title="' + date.toLocaleString() + '">' + date.toISOString().substring(0, 10) + '</span>';
      },
      duration: function (value) {
        let h = Math.floor(value / 3600);
        let m = Math.floor((value - h * 3600) / 60);
        let s = value % 60;
        if (h && m < 10) {
          m = '0' + m;
        }
        if (m && s < 10) {
          s = '0' + s;
        }
        return (h ? h + ':' : '') + m + ':' + s;
      },
      refresh: function () {
        this.$refs.vuetable.reload();
      },
      hide: function (data) {
        axios.delete('/bilibili/' + data.id).then(() => {
          this.refresh();
        });
      },
      refreshVideo: function (data) {
        axios.post('/bilibili/' + data.id + '/refresh').then(() => {
          this.refresh();
        });
      },
      block: function (data) {
        const body = {
          userId: data.authodId,
          name: data.author,
          video: 'https://www.bilibili.com/video/av' + data.id,
          title: data.title,
        };
        axios.post('/bilibili/block', body).then(() => {
          this.refresh();
        });
      },
      onSubmit() {
        this.modal = false
        axios.post('/bilibili?bvid=' + this.bvid).then(() => {
          this.bvid = ''
          this.refresh();
        });
      },
    }
  };
</script>
